class HorizontalScrollCacheStateManager {
  private state: Record<string, unknown> = {}

  get = <T>(key: string): T | undefined => {
    return this.state[key] as T | undefined
  }

  set = <T>(key: string, value: T) => {
    this.state[key] = value
  }
}

const horizontalScrollCacheStateManager = new HorizontalScrollCacheStateManager()

export default horizontalScrollCacheStateManager
